import styled from 'styled-components';

import { resizingImg } from '@/utils/image';

interface Props {
  url: string;
  size: number;
}

const NurseProfile = ({ url, size }: Props) => {
  const resizingImgUrl = resizingImg({
    originUrl: url,
    width: size * 3,
    height: size * 3,
    quality: 100,
  });
  return (
    <Wrapper size={size}>
      <NurseImage url={resizingImgUrl} size={size} />
      <BackgroundImage size={size} />
    </Wrapper>
  );
};

export default NurseProfile;

const Wrapper = styled.span<{ size: number }>`
  display: flex;
  position: relative;
  border-radius: 50%;
  overflow: hidden;

  ${({ theme, size }) => `
    border: 1px solid ${theme.color.gray200};
    width: ${size}px;
    height: ${size}px;
  `}
`;

const NurseImage = styled.span<{ url: string; size: number }>`
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  z-index: 1;

  ${({ url, size }) => `
    background-image: url(${url});
    width: ${size - 1}px;
    height: ${size - 1}px;
`};
`;

const BackgroundImage = styled.img<{ size: number }>`
  object-fit: cover;
  position: absolute;
  top: 0;
  background-color: white;

  ${({ size }) => `
    width: ${size - 1}px;
    height: ${size - 1}px;
  `};
`;
